import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SocialLinks from "./SocialLinks";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo" aria-label="TraveLina">
            <img
              src="/images/travelina-logo.png"
              alt="TraveLina – agencija za putovanja"
              className="logo-image footer-logo-image"
              width={220}
              height={48}
            />
          </Link>
          <div>© {year} <a href="http://linatravelina.eu/" target="_blank" rel="noopener noreferrer" style={{ color: "#4b5563", textDecoration: "none" }}>linatravelina.eu</a> · {t("footer.rights")}</div>
          <div style={{ marginTop: "0.5rem", fontSize: "0.75rem" }}>
            TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA,
            <br />
            VL. LINA SKENDER, CESARICA, PRIMORSKA 1
            <br />
            Tel: +385 91 214 4477
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem", fontSize: "0.75rem" }}>
          <Link to="/privacy" style={{ color: "#4b5563", textDecoration: "none" }}>
            {t("footer.privacy")}
          </Link>
          <Link to="/terms" style={{ color: "#4b5563", textDecoration: "none" }}>
            {t("footer.links")}
          </Link>
          <Link to="/insurance" style={{ color: "#4b5563", textDecoration: "none" }}>
            🛡 {t("footer.insurance")}
          </Link>
          <Link to="/payment" style={{ color: "#4b5563", textDecoration: "none" }}>
            💳 {t("footer.payment")}
          </Link>
          <Link to="/complaints" style={{ color: "#4b5563", textDecoration: "none" }}>
            📩 {t("footer.complaints")}
          </Link>
          <div className="footer-social-wrap" style={{ marginTop: "0.35rem" }}>
            <SocialLinks variant="footer" />
          </div>
        </div>
      </div>
    </footer>
  );
}
